export enum MasterPlanUrls {
  GetPlanContainers = '/api/PlanContainer/GetPlanContainers',
  HDMasterPlans = '/api/PlanContainer/GetHDMasterPlans',
  CreatePlanContainer = '/api/PlanContainer/CreatePlanContainer',
  EditPlanContainer = '/api/PlanContainer/EditPlanContainer',
  GetPlanContainerLocations = "/api/PlanContainer/GetPlanContainerLocations",
  GetMasterPlanLocations = "/api/PlanContainer/GetMasterPlanLocations",
  DeleteMasterPlan = '/api/PlanContainer/DeletePlanContainer',
  CommitPlan = '/api/Plan/CommitPlan',
  CreateMasterPlanLocation = '/api/PlanContainer/CreatePlanContainerLocation',
  GetLocationCountByLocationType='/api/PlanContainer/GetPlanContainerLocationCountByLocationType',
  GetPlanContainerById = '/api/PlanContainer/GetPlanContainerById',
  GetPlanContainerLocationById = '/api/PlanContainer/GetMasterPlanLocationById',
  EditPlanContainerLocation = '/api/PlanContainer/EditPlanContainerLocation',
  GetMasterLocationDetailsById='/api/PlanContainer/GetLocationDetailsFromPlanContainerLocations',
  GetLocationCountByProduct='/api/PlanContainer/GetPlanContainerLocationCountByProduct',
  GetPlanContainerByPlanId = '/api/PlanContainer/GetPlanContainerByPlanId',
  GetMasterPlanTypes = '/api/PlanContainer/GetPlanContainerTypes',
  GetTimeZones = '/api/TimeZone/GetTimeZones',
}
